import { format, parseISO } from "date-fns";

export function formatTimeRange(event) {
  if (event.allDay) return "All Day";

  const start = format(parseISO(event.start), "h:mm a");
  const end = format(parseISO(event.end), "h:mm a");

  // Remove :00 if exact hour
  const clean = t => t.replace(":00", "");

  return `${clean(start)} - ${clean(end)}`;
}

/** Short time for month view: "5PM", "6:30PM", or "" for all-day (no prefix). Omit :00 when on the hour. */
export function formatShortTime(event) {
  if (event.allDay) return "";
  const d = parseISO(event.start);
  const hasMinutes = d.getMinutes() !== 0;
  const str = hasMinutes ? format(d, "h:mma") : format(d, "ha");
  return str.toUpperCase();
}
